import { v4 as uuidv4, validate as validateUuid } from 'uuid'
import MobileDetect from 'mobile-detect'

export const VISITOR_COOKIE = '_visitor_id'

export default ({ store }) => {
  // Upsert context values on app bootstrap.
  // Initialisation in store module itself is not possible due to static SSR.
  upsertContextForKeyAndValueIfNotExists(store, 'deviceType', getDeviceType())
  upsertContextForKeyAndValueIfNotExists(store, 'sessionId', getUuid())

  const visitorIdFromCookie = getVisitorIdFromCookie(document.cookie)

  if (visitorIdFromCookie) {
    store.commit('context/set', { visitorId: visitorIdFromCookie })
  } else {
    upsertContextForKeyAndValueIfNotExists(store, 'visitorId', getUuid())
  }

  store.dispatch('lead/add', {
    key: 'country',
    value: store.getters['context/get']('country'),
  })

  store.dispatch('lead/add', {
    key: 'language',
    value: store.getters['context/get']('language'),
  })
}

/**
 * @param {object} store
 * @param {string} key
 * @param {any} valueIfNotExists
 */
export function upsertContextForKeyAndValueIfNotExists(
  store,
  key,
  valueIfNotExists,
) {
  const value = store.getters['context/get'](key, valueIfNotExists)

  if (value !== valueIfNotExists) {
    return
  }

  store.commit('context/set', { [key]: value })
}

/**
 * @param {string} cookie
 * @returns {string|undefined}
 */
export function getVisitorIdFromCookie(cookie) {
  for (const pair of cookie.split(';')) {
    const separator = pair.indexOf('=')

    if (
      separator === -1 ||
      pair.slice(0, separator).trim() !== VISITOR_COOKIE
    ) {
      continue
    }

    const id = pair
      .slice(separator + 1)
      .trim()
      .split('.')[0]

    return validateUuid(id) ? id : undefined
  }
}

/**
 * @returns {*|string}
 */
export function getUuid() {
  return uuidv4()
}

/**
 * @returns {string}
 */
export function getDeviceType() {
  const md = new MobileDetect(window.navigator.userAgent)

  if (md.tablet()) {
    return 'tablet'
  }

  if (md.mobile()) {
    return 'mobile'
  }

  return 'desktop'
}
